import React from 'react';
import { ConnectionWarning, ConnectionIndicator } from '@/core/messaging/export';
import { ReaderIndicator } from '@/modules/calendar/export';

export default function ConnectionIndicators({ children }: React.PropsWithChildren<{}>) {
  return (
    <>
      <ConnectionWarning />
      {children}
      <div
        className={'bg-black p-1'}
        id={'connectionIndicator'}
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          zIndex: 100,
        }}
      >
        <ConnectionIndicator />
      </div>
      <div
        className={'bg-black p-1 text-base-light'}
        id={'readerIndicator'}
        style={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        <ReaderIndicator />
      </div>
    </>
  );
}
